export default {
  title: 'Taal',
  save_changes: 'Wijzigingen opslaan',
};
